import React, { useEffect, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import { Menu } from "@mui/icons-material";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { toAbsoluteUrl } from "../../../../../_metronic";
import NestedList from "../../../../partials/content/NestedList";
import AboutThisGuide from "./aboutThisGuide/aboutThisGuide";
import Usage from "./gettingStarted/usage/usage";
import Learn from "./gettingStarted/learn/learn";
import FAQs from "./gettingStarted/faqs/faqs";
import SupportedPlatforms from "./gettingStarted/supportedPlatforms/supportedPlatforms";
import Community from "./gettingStarted/community/community";
import Support from "./gettingStarted/support/support";
import Lead from "./modules/crm/lead/lead";
import SalesJourney from "./modules/crm/salesJourney/salesJourney";
import SalesLifeCycle from "./modules/crm/salesLifeCycle/salesLifeCycle";
import CRMReports from "./modules/crm/crmReports/crmReports";
import Customer from "./modules/sales/customer/customer";
import Outlet from "./modules/sales/outlet/outlet";
import Quotation from "./modules/sales/quotation/quotation";
import SalesOrder from "./modules/sales/salesOrder/salesOrder";
import ItemSellingPrice from "./modules/sales/itemSellingPrice/itemSellingPrice";
import ItemPackage from "./modules/sales/itemPackage/itemPackage";
import Discount from "./modules/sales/discount/discount";
import PointOfSales from "./modules/sales/pointOfSales/pointOfSales";
import OnlineShop from "./modules/sales/onlineShop/onlineShop";
import SalesReports from "./modules/sales/salesReports/salesReports";
import Warehouse from "./modules/inventory/warehouse/warehouse";
import Item from "./modules/inventory/item/item";
import StockManagement from "./modules/inventory/stockManagement/stockManagement";
import OperationLifeCycle from "./modules/inventory/operationLifeCycle/operationLifeCycle";
import InventoryReports from "./modules/inventory/inventoryReports/inventoryReports";
import Vendor from "./modules/procurement/vendor/vendor";
import PurchaseRequest from "./modules/procurement/purchaseRequest/purchaseRequest";
import Rfq from "./modules/procurement/rfq/rfq";
import Contract from "./modules/procurement/contract/contract";
import PurchaseOrder from "./modules/procurement/purchaseOrder/purchaseOrder";
import ProcurementReports from "./modules/procurement/procurementReports/procurementReports";
import JournalEntry from "./modules/finance/journalEntry/journalEntry";
import Invoice from "./modules/finance/invoice/invoice";
import Payment from "./modules/finance/payment/payment";
import Asset from "./modules/finance/asset/asset";
import OpenClosePeriod from "./modules/finance/openClosePeriod/openClosePeriod";
import ExchangeRate from "./modules/finance/exchangeRate/exchangeRate";
import FinanceReports from "./modules/finance/financeReports/financeReports";
import User from "./modules/user/user/user";
import UserGroup from "./modules/user/userGroup/userGroup";
import Authorization from "./modules/user/authorization/authorization";
import UserReports from "./modules/user/userReports/userReports";
import Setup from "./modules/setup/setup";
import Platform_v1_0_0 from "./versions_releaseNotes/platform_v1_0_0/platform_v1_0_0";
import GlobalPartner from "./discoverMore/affiliates/globalPartner/globalPartner";
import GlobalCustomer from "./discoverMore/affiliates/globalCustomer/globalCustomer";
import Investor from "./discoverMore/affiliates/investor/investor";
import Showcase from "./discoverMore/showcase/showcase";
import Roadmap from "./discoverMore/roadmap/roadmap";
import Vision from "./discoverMore/vision/vision";
import Team from "./discoverMore/team/team";
import Language from "./discoverMore/language/language";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import { Image } from "react-bootstrap";
import { DateTime } from "luxon";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    marginTop: "-25px",
    marginLeft: "-25px",
    marginRight: "-25px",
    backgroundColor: "#ffffff",
    minHeight: `calc( 100vh - 119px )`,
    maxHeight: `calc( 100vh - 119px )`,
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
    color: "white",
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    [theme.breakpoints.up("sm")]: {
      marginTop: "-25px",
      minHeight: `calc( 100vh - 119px )`,
      maxHeight: `100%`,
    },
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      paddingLeft: drawerWidth + theme.spacing(3),
    },
    padding: theme.spacing(3),
    overflowY: "auto",
  },
}));

function Guidances({ history }, props) {
  const { companyProfile, userPreferences } = useGlobalData();
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const today = DateTime.now().year;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [component, setComponent] = useState(<AboutThisGuide />);

  const lists = [
    {
      key: "About This Guide",
      label: "About This Guide",
      icon: "",
    },
    {
      key: "Getting Started",
      label: "Getting Started",
      icon: "",
      items: [
        {
          key: "Usage",
          label: "Usage",
          icon: "",
        },
        {
          key: "Learn",
          label: "Learn",
          icon: "",
        },
        {
          key: "FAQs",
          label: "FAQs",
          icon: "",
        },
        {
          key: "Supported Platforms",
          label: "Supported Platforms",
          icon: "",
        },
        {
          key: "Community",
          label: "Community",
          icon: "",
        },
        {
          key: "Support",
          label: "Support",
          icon: "",
        },
      ],
    },
    {
      key: "Modules",
      label: "Modules",
      icon: "",
      items: [
        {
          key: "CRM",
          label: "CRM",
          icon: "",
          subitems: [
            {
              key: "Lead",
              label: "Lead",
              icon: "",
            },
            {
              key: "Sales Life Cycle",
              label: "Sales Life Cycle",
              icon: "",
            },
            {
              key: "Sales Journey",
              label: "Sales Journey",
              icon: "",
            },
            {
              key: "CRM Reports",
              label: "CRM Reports",
              icon: "",
            },
          ],
        },
        {
          key: "Sales",
          label: "Sales",
          icon: "",
          subitems: [
            {
              key: "Customer",
              label: "Customer",
              icon: "",
            },
            {
              key: "Outlet",
              label: "Outlet",
              icon: "",
            },
            {
              key: "Quotation",
              label: "Quotation",
              icon: "",
            },
            {
              key: "Sales Order",
              label: "Sales Order",
              icon: "",
            },
            {
              key: "Item Selling Price",
              label: "Item Selling Price",
              icon: "",
            },
            {
              key: "Item Package",
              label: "Item Package",
              icon: "",
            },
            {
              key: "Discount",
              label: "Discount",
              icon: "",
            },
            {
              key: "Point Of Sales",
              label: "Point Of Sales",
              icon: "",
            },
            {
              key: "Sales Reports",
              label: "Sales Reports",
              icon: "",
            },
          ],
        },
        {
          key: "Inventory",
          label: "Inventory",
          icon: "",
          subitems: [
            {
              key: "Warehouse",
              label: "Warehouse",
              icon: "",
            },
            {
              key: "Item",
              label: "Item",
              icon: "",
            },
            {
              key: "Stock Management",
              label: "Stock Management",
              icon: "",
            },
            {
              key: "Operation Life Cycle",
              label: "Operation Life Cycle",
              icon: "",
            },
            {
              key: "Inventory Reports",
              label: "Inventory Reports",
              icon: "",
            },
          ],
        },
        {
          key: "Procurement",
          label: "Procurement",
          icon: "",
          subitems: [
            {
              key: "Vendor",
              label: "Vendor",
              icon: "",
            },
            {
              key: "Purchase Request",
              label: "Purchase Request",
              icon: "",
            },
            {
              key: "Request For Quotation",
              label: "Request For Quotation",
              icon: "",
            },
            {
              key: "Contract",
              label: "Contract",
              icon: "",
            },
            {
              key: "Purchase Order",
              label: "Purchase Order",
              icon: "",
            },
            {
              key: "Procurement Reports",
              label: "Procurement Reports",
              icon: "",
            },
          ],
        },
        {
          key: "Finance",
          label: "Finance",
          icon: "",
          subitems: [
            {
              key: "Journal Entry",
              label: "Journal Entry",
              icon: "",
            },
            {
              key: "Invoice",
              label: "Invoice",
              icon: "",
            },
            {
              key: "Payment",
              label: "Payment",
              icon: "",
            },
            {
              key: "Asset",
              label: "Asset",
              icon: "",
            },
            {
              key: "Open Close Period",
              label: "Open Close Period",
              icon: "",
            },
            {
              key: "Exchange Rate",
              label: "Exchange Rate",
              icon: "",
            },
            {
              key: "Finance Reports",
              label: "Finance Reports",
              icon: "",
            },
          ],
        },
        {
          key: "User",
          label: "User",
          icon: "",
          subitems: [
            {
              key: "User",
              label: "User",
              icon: "",
            },
            {
              key: "User Group",
              label: "User Group",
              icon: "",
            },
            {
              key: "Authorization",
              label: "Authorization",
              icon: "",
            },
            {
              key: "User Reports",
              label: "User Reports",
              icon: "",
            },
          ],
        },
        {
          key: "Setup",
          label: "Setup",
          icon: "",
        },
      ],
    },
    {
      key: "Versions & Release Notes",
      label: "Versions & Release Notes",
      icon: "",
      items: [
        {
          key: "Platform v1.0.0",
          label: "Platform v1.0.0",
          icon: "",
        },
      ],
    },
    {
      key: "Discover More",
      label: "Discover More",
      icon: "",
      items: [
        {
          key: "Affiliates",
          label: "Affiliates",
          icon: "",
          subitems: [
            {
              key: "Global Customer",
              label: "Global Customer",
              icon: "",
            },
            {
              key: "Global Partner",
              label: "Global Partner",
              icon: "",
            },
            {
              key: "Investor",
              label: "Investor",
              icon: "",
            },
          ],
        },
        {
          key: "Showcase",
          label: "Showcase",
          icon: "",
        },
        {
          key: "Roadmap",
          label: "Roadmap",
          icon: "",
        },
        {
          key: "Vision",
          label: "Vision",
          icon: "",
        },
        {
          key: "Team",
          label: "Team",
          icon: "",
        },
        {
          key: "Language",
          label: "Language",
          icon: "",
        },
      ],
    },
  ];

  const defaultSelected = "About This Guide";

  async function handleSelectItem(key) {
    let component;
    switch (key) {
      case "About This Guide":
        component = <AboutThisGuide />;
        break;
      case "Usage":
        component = <Usage />;
        break;
      case "Learn":
        component = <Learn />;
        break;
      case "FAQs":
        component = <FAQs />;
        break;
      case "Supported Platforms":
        component = <SupportedPlatforms />;
        break;
      case "Community":
        component = <Community />;
        break;
      case "Support":
        component = <Support />;
        break;
      case "Lead":
        component = <Lead />;
        break;
      case "Sales Life Cycle":
        component = <SalesLifeCycle />;
        break;
      case "Sales Journey":
        component = <SalesJourney />;
        break;
      case "CRM Reports":
        component = <CRMReports />;
        break;
      case "Customer":
        component = <Customer />;
        break;
      case "Outlet":
        component = <Outlet />;
        break;
      case "Quotation":
        component = <Quotation />;
        break;
      case "Sales Order":
        component = <SalesOrder />;
        break;
      case "Item Selling Price":
        component = <ItemSellingPrice />;
        break;
      case "Item Package":
        component = <ItemPackage />;
        break;
      case "Discount":
        component = <Discount />;
        break;
      case "Point Of Sales":
        component = <PointOfSales />;
        break;
      case "Sales Reports":
        component = <SalesReports />;
        break;
      case "Warehouse":
        component = <Warehouse />;
        break;
      case "Item":
        component = <Item />;
        break;
      case "Stock Management":
        component = <StockManagement />;
        break;
      case "Operation Life Cycle":
        component = <OperationLifeCycle />;
        break;
      case "Inventory Reports":
        component = <InventoryReports />;
        break;
      case "Vendor":
        component = <Vendor />;
        break;
      case "Purchase Request":
        component = <PurchaseRequest />;
        break;
      case "Request For Quotation":
        component = <Rfq />;
        break;
      case "Contract":
        component = <Contract />;
        break;
      case "Purchase Order":
        component = <PurchaseOrder />;
        break;
      case "Procurement Reports":
        component = <ProcurementReports />;
        break;
      case "Journal Entry":
        component = <JournalEntry />;
        break;
      case "Invoice":
        component = <Invoice />;
        break;
      case "Payment":
        component = <Payment />;
        break;
      case "Asset":
        component = <Asset />;
        break;
      case "Open Close Period":
        component = <OpenClosePeriod />;
        break;
      case "Exchange Rate":
        component = <ExchangeRate />;
        break;
      case "Finance Reports":
        component = <FinanceReports />;
        break;
      case "User":
        component = <User />;
        break;
      case "User Group":
        component = <UserGroup />;
        break;
      case "Authorization":
        component = <Authorization />;
        break;
      case "User Reports":
        component = <UserReports />;
        break;
      case "Setup":
        component = <Setup />;
        break;
      case "Platform v1.0.0":
        component = <Platform_v1_0_0 />;
        break;
      case "Global Customer":
        component = <GlobalCustomer />;
        break;
      case "Global Partner":
        component = <GlobalPartner />;
        break;
      case "Investor":
        component = <Investor />;
        break;
      case "Showcase":
        component = <Showcase />;
        break;
      case "Roadmap":
        component = <Roadmap />;
        break;
      case "Vision":
        component = <Vision />;
        break;
      case "Team":
        component = <Team />;
        break;
      case "Language":
        component = <Language />;
        break;
      default:
        component = <AboutThisGuide />;
        break;
    }
    setComponent(component);
  }

  const drawer = (
    <div>
      <div
        className={classes.toolbar}
        style={{ marginTop: "10px", marginBottom: "10px" }}
      >
        <div className="d-flex flex-column align-items-center justify-content-between">
          <a href="http://invifo.com" target="_blank" rel="noopener noreferrer">
            <Typography align="center">
              <Image
                src={toAbsoluteUrl("/media/logos/logo-mini-lg.png")}
                style={{
                  width: "5rem",
                  height: "auto",
                }}
                alt="Invifo Enterprise Logo"
                fluid
              />
            </Typography>
          </a>
        </div>
        <Typography variant="subtitle1" align="center">
          <strong>
            {today.toString()}&nbsp;&copy;&nbsp;
            <a
              href="http://invifo.com"
              target="_blank"
              rel="noopener noreferrer"
              className="kt-link text-hover-primary"
            >
              Invifo Enterprise
            </a>
            .
          </strong>
        </Typography>
        <Typography variant="subtitle1" align="center">
          <strong>All Rights Reserved.</strong>
        </Typography>
        <Typography variant="subtitle2" align="center">
          {companyProfile.platformVersion}
        </Typography>
      </div>
      <Divider />
      <NestedList
        lists={lists}
        onSelectItem={handleSelectItem}
        defaultSelected={defaultSelected}
      />
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const actionButtons = [];
  actionButtons.push({
    title: "",
    color: "label-brand",
    icon: "fas fa-backward",
    onClick: () => {
      history.push("/menu");
    },
  });

  return (
    <React.Fragment>
      <PageSubHeader
        title="Guidance"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/common/guidances",
            title: "Guidances",
            active: true,
          },
        ]}
        actionButtons={actionButtons}
      />
      <div className={classes.root}>
        <CssBaseline />
        <Hidden smUp implementation="css">
          <AppBar
            className={classes.appBar}
            style={{
              backgroundAttachment: "fixed",
              backgroundImage: `${
                userPreferences.invifoThemeID > 0
                  ? `url(${toAbsoluteUrl(
                      `/media/bg/${userPreferences.invifoTheme.imageName}`
                    )})`
                  : userPreferences.customThemeID > 0
                  ? "url(" + userPreferences.customTheme.imagePath + ")"
                  : `url(${toAbsoluteUrl("/media/bg/bg-aqua.jpg")})`
              }`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              position: "unset",
            }}
          >
            <Toolbar>
              <IconButton
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={classes.menuButton}
              >
                <Menu />
              </IconButton>
              <Typography className="text-white" variant="h6" noWrap>
                Guidances
              </Typography>
            </Toolbar>
          </AppBar>
        </Hidden>
        <Hidden xsDown implementation="css">
          <AppBar
            className={classes.appBar}
            style={{
              backgroundAttachment: "fixed",
              backgroundImage: `${
                userPreferences.invifoThemeID > 0
                  ? `url(${toAbsoluteUrl(
                      `/media/bg/${userPreferences.invifoTheme.imageName}`
                    )})`
                  : userPreferences.customThemeID > 0
                  ? "url(" + userPreferences.customTheme.imagePath + ")"
                  : `url(${toAbsoluteUrl("/media/bg/bg-aqua.jpg")})`
              }`,
              backgroundPosition: "center",
              backgroundSize: "cover",
              position: "unset",
            }}
          >
            <Toolbar>
              <IconButton
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={classes.menuButton}
              >
                <Menu />
              </IconButton>
              <Typography className="text-white" variant="h6" noWrap>
                Guidances
              </Typography>
            </Toolbar>
          </AppBar>
        </Hidden>
        <nav className={classes.drawer}>
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Hidden smUp implementation="css">
            <Drawer
              container={container}
              variant="temporary"
              anchor={theme.direction === "rtl" ? "right" : "left"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </nav>
        <main className={classes.content}>{component}</main>
      </div>
    </React.Fragment>
  );
}

export default Guidances;
